export type CarouselDirection = -1 | 0 | 1

/**
 * Resolves the next logical carousel slide without crossing a boundary.
 *
 * @param currentIndex - Current zero-based slide index.
 * @param direction - Requested movement: previous, unchanged, or next.
 * @param slideCount - Total number of logical slides.
 * @returns The bounded zero-based target slide index.
 */
export function getCarouselSlideIndex(
  currentIndex: number,
  direction: CarouselDirection,
  slideCount: number
): number {
  if (!Number.isInteger(slideCount) || slideCount < 1) {
    throw new RangeError('slideCount must be a positive integer')
  }

  if (!Number.isInteger(currentIndex) || currentIndex < 0 || currentIndex >= slideCount) {
    throw new RangeError('currentIndex must identify an existing slide')
  }

  if (![-1, 0, 1].includes(direction)) {
    throw new RangeError('direction must move at most one logical slide')
  }

  return Math.min(Math.max(currentIndex + direction, 0), slideCount - 1)
}
